module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp_m.74100724ec2f27bd92ada2000ec318e0.png";